import { FC } from "react";

import dynamic from "next/dynamic";

import { DonationFormSkeletonProps } from "./types";

export const DonationFormSkeleton = dynamic(
  () => import("./DonationFormSkeletonSsr").then((mod) => mod.DonationFormSkeletonSsr),
  {
    ssr: false,
  }
) as FC<DonationFormSkeletonProps>;
